module.exports = __webpack_public_path__ + "static/media/icon-ylk-input.png";